<script lang="ts">
    import DonationRequestDetailComponent from '../../components/charity/donation/detail.svelte';
    
    export let params: { id: string };
  </script>
 
  <DonationRequestDetailComponent {params} /> 